import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SecurityService, UserExpireInfo, UserInfo } from '../../../services/security.service';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { Configuration } from '../../../../app.configuration.service';

@Component({
    selector: 'app-unlock',
    templateUrl: './unlock.component.html',
    styleUrls: ['./unlock.component.scss'],
    standalone: false
})
export class UnlockComponent implements OnInit, OnDestroy {

  public loginExpireProgress = 100;
  public loginExpireSeconds = 0;
  public loginExpirePercentage = 0;

  public username: string;
  public password: string;
  public errorMessage: string;

  public isSaving: boolean;

  private expiresLoginPopup = 0;
  private subUserExpiring: ISubscription = null;
  private subUserInfo: ISubscription = null;

  constructor(private modalActive: NgbActiveModal, private configuration: Configuration, private securityService: SecurityService) { }

  ngOnInit() {
    this.expiresLoginPopup = this.configuration.expiresLoginPopup;

    this.subUserInfo = this.securityService.UserInfoSubscribe((userInfo: UserInfo) => {
      if (userInfo) {
        this.username = userInfo.username;
      } else {
        this.username = null;
      }
    });

    this.subUserExpiring = this.securityService.UserExpiringSubscribe((userExpireInfo: UserExpireInfo) => {
      this.loginExpireProgress = Math.floor(userExpireInfo.timeout / userExpireInfo.totalTimeout * 100);
      // console.log('XXX HC1: TOKEN Expiring in % = ' + this.loginExpireProgress);

      this.loginExpireSeconds = Math.floor(userExpireInfo.timeout / 1000);
      this.loginExpirePercentage = this.loginExpireSeconds / this.expiresLoginPopup * 100;

      this.loginExpireSeconds--;

      if (this.loginExpireSeconds <= 0) {
        // the popup requesting a new login is presented to the user
        // stop background renovation, etc
        this.securityService.setMonitoringExpiration(false);
      }
    });
  }

  public manterSessao() {
    this.isSaving = true;
    this.securityService
      .refresh()
      .subscribe(sucess => {
        this.isSaving = false;
        if (sucess) {
          this.modalActive.close('continuar');
        } else {
          this.errorMessage = 'Não foi possível renovar a sua sessão.';
        }
      },
        error => {
          this.isSaving = false;
          console.log(error);
          this.errorMessage = error;
        });
  }

  public onLogin() {
    this.isSaving = true;
    this.securityService
      .login(this.username, this.password)
      .subscribe(sucess => {
        this.isSaving = false;
        if (sucess) {
          this.modalActive.close('continuar');
        } else {
          this.errorMessage = 'Falha de Autenticação - O conjunto Utilizador/Palavra-passe, não foi validado;';
        }
      },
        error => {
          this.isSaving = false;
          console.log(error);
          this.errorMessage = error;
        });
  }

  public logout() {
    this.modalActive.close('logout');
    this.securityService.logout(true, false);
  }

  ngOnDestroy() {
    if (this.subUserInfo) { this.subUserInfo.unsubscribe(); }
    if (this.subUserExpiring) { this.subUserExpiring.unsubscribe(); }
  }
}
